<script lang="ts">
  export type StatusVariant =
    | 'issued'
    | 'redeemed'
    | 'pending'
    | 'invited'
    | 'cancelled'
    | 'completed'
    | 'refunded'
    | 'expired'
    | 'released'
    | 'committed';

  export let status: StatusVariant = 'issued';
  export let label: string | null = null;
</script>

<span class={`status-badge status-${status}`}>
  {#if label}
    {label}
  {:else}
    {status}
  {/if}
</span>

<style>
  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.2rem 0.6rem;
    border-radius: var(--radius-md);
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  .status-issued {
    background: rgba(74, 163, 240, 0.18);
    color: #90caff;
  }

  .status-redeemed {
    background: rgba(110, 230, 150, 0.18);
    color: #8defb3;
  }

  .status-pending,
  .status-invited {
    background: rgba(255, 206, 115, 0.22);
    color: #ffce73;
  }

  .status-cancelled {
    background: rgba(255, 96, 96, 0.24);
    color: #ff9a9a;
  }

  .status-completed,
  .status-committed {
    background: rgba(110, 230, 150, 0.2);
    color: #8defb3;
  }

  .status-expired {
    background: rgba(255, 96, 96, 0.24);
    color: #ff9a9a;
  }

  .status-released {
    background: rgba(148, 161, 178, 0.18);
    color: #d1d7e0;
  }
</style>
